import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

export function createMessage (data) {
  return {
    ...data,
    time_created: addUTCTimeZoneDesignator(data.time_created),
  };
}
